import {Injectable} from '@angular/core';
import {Resolve, Router, ActivatedRouteSnapshot} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from '../_services/notification.service';
import { VehiclePosition } from '../_models/vehiclePosition';
import { MapService } from '../_services/map.service';

@Injectable()
export class PositionRouteResolver implements Resolve<VehiclePosition[]> {
    constructor(private mapService: MapService, private router: Router,
        private notify: NotificationService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<VehiclePosition[]> {
        return this.mapService.getPositions(route.params['date'], route.params['id']).pipe(
            catchError(error => {
                this.notify.error(error);
                this.router.navigate(['/routes']);
                return of(null);
            })
        );
    }
}
